import { render, staticRenderFns } from "./ReportsTableWithLazyLoading.vue?vue&type=template&id=3c754a66&scoped=true"
import script from "./ReportsTableWithLazyLoading.vue?vue&type=script&lang=js"
export * from "./ReportsTableWithLazyLoading.vue?vue&type=script&lang=js"
import style0 from "./ReportsTableWithLazyLoading.vue?vue&type=style&index=0&id=3c754a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c754a66",
  null
  
)

export default component.exports